import { render, staticRenderFns } from "./OldExpenses.vue?vue&type=template&id=3f66587c&scoped=true&"
import script from "./OldExpenses.vue?vue&type=script&lang=js&"
export * from "./OldExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f66587c",
  null
  
)

export default component.exports